/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { DigitizePointService } from '@map/command/digitize-point/digitize-point.service';
import { DigitizableLayer } from '@map/command/digitize-point/state/digitize-point-config.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'dash-gis-digitize-point-report',
    templateUrl: './digitize-point-report.component.html',
    imports: [ MatButton, AsyncPipe ]
})
export class DigitizePointReportComponent implements OnInit {
    @Input() buttonText: string;
    @Input() layerName: string;

    potentiallyDigitizableLayers$: Observable<DigitizableLayer[]>;
    digitizableLayers$: Observable<DigitizableLayer[]>;
    canCreatePoints$: Observable<boolean>;

    constructor(private digitizeService: DigitizePointService) {
        this.potentiallyDigitizableLayers$ = this.digitizeService.potentiallyDigitizableLayers$;
        this.digitizableLayers$ = this.digitizeService.digitizableLayers$;
        this.canCreatePoints$ = this.potentiallyDigitizableLayers$.pipe(map((p) => p.length > 0));
    }

    ngOnInit(): void {}

    addPoint(layerName: string) {
        this.digitizeService.addPoint(layerName);
    }
}
